/**
 * On page load
 **/
$(document).ready( function(){
	// Start your website!
	console.log('Loaded!');
	PageSetup();
});

function PageSetup(){
    //ToggleContent();
    RegionalCampingMap();
}

function ToggleContent(){
    $('.toggle-button').click(function(e){
    	e.preventDefault();
        $(this).parent('.togglable').children('.togglable-content').slideToggle(200);
        $(this).toggleClass('open');
        if( $(this).children('.fa').length ){
        	$(this).children('.fa').toggleClass('fa-plus');
        	$(this).children('.fa').toggleClass('fa-minus');
        }
    });
}

function RegionalCampingMap() {
    
    // Click on island
    $('.islandLink').bind("click", function(){
        $('#fullMap').animate({opacity:0,height:0,'z-index':'0'}, 500);
    })
    
    // Swap Islands
    $('#northIslandLink,#swapNorthIslandLink').bind("click", function(){
        $('#southIslandDetail').animate({opacity:0,height:0}, 500);
        $('#southIslandDetail #SIMapRegion').css({height:0});
        $('ul#southIslandDetail').children('.regionLI').hide();
        
        $('#northIslandDetail').animate({opacity:100,height:'484px'},500);
        $('#northIslandDetail #NIMapRegion').css({height:'484px'});
    })
    $('#southIslandLink,#swapSouthIslandLink').bind("click", function(){
        $('#northIslandDetail').animate({opacity:0,height:0}, 500);
        $('#northIslandDetail #NIMapRegion').css({height:0});
        
        $('#southIslandDetail').animate({opacity:100,height:'484px'},500);
        $('#southIslandDetail #SIMapRegion').css({height:'484px'});
        $('ul#southIslandDetail').children('.regionLI').show();
    })
    
    // Location dots/info
    $('.regionLI').bind({
        mouseenter: function(){
            var region = $(this).attr('id');
            $('.mapRegion').addClass(region);
            $(this).css('z-index',200);
            $(this).animate({width:'274px',height:'300px'}, 500);
            $(this).children('.hoverInfo').css('display','block').animate({opacity:100}, 500);
            $(this).children('.dot').addClass('hover');
            return;
        },
        mouseleave: function(){
            var region = $(this).attr('id');
            $('.mapRegion').removeClass(region);
            $(this).css('z-index',120);
            $(this).animate({width:'19px',height:'19px'}, 500);
            $(this).children('.hoverInfo').css('display','none').animate({opacity:0},500);  
            $(this).children('.dot').removeClass('hover');
        }
    })

}



//////////////////
// WEBPACK FOOTER
// ./site/js/global/effects.js
// module id = 4
// module chunks = 0